import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function InformationCard(props) {
    const listItems = props.description.split("$");
    console.log(listItems);
    return (
        <div className="info-cards">
      <span className="info-card-icon">
        <FontAwesomeIcon className="info-fa-icon" icon={props.icon}/>
      </span>
            <p className="info-card-title">{props.title}</p>
            <div className="info-card-description">
                <ul>
                    {listItems.map((item, index) =>
                        <li className="info-card-list" key={index}>{item}</li>)}
                </ul>
            </div>
        </div>
    );
}

export default InformationCard;
